import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import AgencyService from "../../../../services/catalogs/AgencyService";

export const REQUEST_UPDATE_AGENCY = "REQUEST_UPDATE_AGENCY";
export const UPDATE_AGENCY_SUCCESS = "UPDATE_AGENCY_SUCCESS";
export const UPDATE_AGENCY_ERROR = "UPDATE_AGENCY_ERROR";

function requestUpdateAgency() {
  return {
    type: REQUEST_UPDATE_AGENCY,
  };
}

function updateAgencySuccess(json) {
  return {
    type: UPDATE_AGENCY_SUCCESS,
    message: json.data,
  };
}

function updateAgencyError(json) {
  return {
    type: UPDATE_AGENCY_ERROR,
    error: json.data,
  };
}

export function updateAgency(agency_id, payload) {
  return (dispatch) => {
    dispatch(requestUpdateAgency());
    return AgencyService.putAgency(agency_id, payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(updateAgencySuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(updateAgency(agency_id, payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(updateAgencyError(json.data));
      }
    });
  };
}
